import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../hooks/useLocale';
import type { AppLocale } from '../i18n/config';

export function AuthLanguagePicker() {
  const { t } = useTranslation();
  const { locale, labels, supportedLocales, setLocale } = useLocale();
  return <label className="auth-language-floating">
    <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a18 18 0 0 1 0 18 18 18 0 0 1 0-18Z"/></svg>
    <select aria-label={t('common.language')} value={locale} onChange={event => void setLocale(event.target.value as AppLocale)}>
      {supportedLocales.map(code => <option key={code} value={code} lang={code}>{labels[code]}</option>)}
    </select>
  </label>;
}
